import { render, staticRenderFns } from "./company-type.vue?vue&type=template&id=101e73ba&"
import script from "./company-type.vue?vue&type=script&lang=js&"
export * from "./company-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports